export interface APIResponse {
    ResponseType: string
    StatusMsg: string
    data: any
    success: boolean
}

export const APIStatus  = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    DATA_NOT_FOUND: 'DATA_NOT_FOUND',
    TRIAL_ALREADY_TAKEN: 'TRIAL_ALREADY_TAKEN',
    PLANALREADYACTIVATED:"PLANALREADYACTIVATED",
}

export enum APIEnv {
    NODE_PREMIUM,
    TAX_PRACTICE,
    NODE_BOOKSTORE,
    NODE_DASHBOARD,
    NODE_REDIS,
    REDIS,
    LEARNING,
    DOT_NET,
    ENDMILE,
    MARKETING,
    NODE_DASHBOARD_SESSION_MANAGEMENT
}

export const APIStatusError = {
    PLAN_NOT_SUBSCRIBED: 'PLAN_NOT_SUBSCRIBED',
    PLAN_EXPIRED:'PLAN_EXPIRED'
}